export const GET_INSTRUMENTS = "GET_INSTRUMENTS";
export const GET_INSTRUMENT_BY_ID = "GET_INSTRUMENT_BY_ID";
export const UPDATE_INSTRUMENT = "UPDATE_INSTRUMENT";
export const DELETE_INSTRUMENT = "DELETE_INSTRUMENT";
export const CREATE_INSTRUMENT = "CREATE_INSTRUMENT";
export const GET_NESTED_INSTRUMENTS = "GET_NESTED_INSTRUMENTS";
